import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import UiGroup from "./UiGroup";

/**
 * 申报地海关详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailCustomhouse extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 关区名称
     */
    Name?: string;
    /**
     * 关区代码
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
}

/**
 * 申报地海关详细-表单校验
 */
export const DtoDetailCustomhouseRules = {
}

/**
 * 申报地海关详细-设置项
 */
export const DtoDetailCustomhouseMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "Name",
    Label: "关区名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Code",
    Label: "关区代码",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Type: EnumMiezzFormItemType.Text,
  },
]
